import {FC, useState} from 'react'
import {DataCDR} from '../../core/_models'
import {useParams} from 'react-router-dom'
import {appsAPI} from '../../../../services/AppsService'
import {CDRModalAi} from '../../components/ai/CDRModalAi'

type Props = {
  data?: DataCDR
}

const CDRAi: FC<Props> = ({data}) => {
  const {appId} = useParams()
  const [show, setShow] = useState(false)
  const {data: app} = appsAPI.useFetchAppByIdQuery(appId!)

  const handleOpen = () => setShow(true)
  const handleClose = () => setShow(false)

  return (
    <div className='d-flex align-items-center justify-content-center'>
      {data?.llm_analysis && (
        <>
          <i className='bi bi-info-circle cursor-pointer fs-4 text-info' onClick={handleOpen} />
          <CDRModalAi
            data={data}
            recordUrl={`${app?.settings.asterisk.record_url}${data.record_url}`}
            show={show}
            handleClose={handleClose}
          />
        </>
      )}
    </div>
  )
}

export {CDRAi}
